<app-page-wrapper [title]="pageTitle()" [loading]="loadingData()" [error]="null">
  <ng-container *ngIf="!loadingData()">
    @if (ownerMode()) {
      <div class="tracker-owner-card-wrap">
        <p-card>
          <div class="tracker-owner-card">
            <div>
              <span class="tracker-eyebrow">Widok właściciela</span>
              <h2>Tracker dla wybranego użytkownika</h2>
              <p>
                Aktualnie przeglądasz:
                <strong>
                  {{ selectedUser()?.firstName ?? 'wybierz' }}
                  {{ selectedUser()?.lastName ?? 'użytkownika' }}
                </strong>
              </p>
            </div>

            <div class="tracker-owner-select">
              <label for="trackerOwnerUser">Użytkownik</label>
              <p-select
                inputId="trackerOwnerUser"
                [options]="ownerUserOptions()"
                optionLabel="fullName"
                optionValue="id"
                [ngModel]="selectedUserId()"
                (ngModelChange)="onOwnerUserChange($event)"
                placeholder="Wybierz użytkownika"
                appendTo="body"
                styleClass="w-full"
              >
                <ng-template let-user pTemplate="item">
                  {{ user.firstName }} {{ user.lastName }}
                </ng-template>
                <ng-template let-user pTemplate="selectedItem">
                  {{ user.firstName }} {{ user.lastName }}
                </ng-template>
              </p-select>
            </div>
          </div>
        </p-card>
      </div>
    }

    <div class="tracker-toolbar-wrap">
      <p-card>
        <div class="tracker-toolbar">
          <div class="tracker-toolbar-copy">
            <span class="tracker-eyebrow">Miesiąc</span>
            <h2>{{ monthLabel() }}</h2>

              @if (selectedWorkItemId()) {
                <p>
                  <span class="tracker-dot">•</span>
                  filtr: {{ selectedWorkItemLabel() }}
                </p>
              }
            <div class="d-flex flex-col">
              <p>
                <span class="tracker-dot">•</span>
                {{ monthEntryCount() }} pozycji
                <span class="tracker-dot">•</span>
                {{ formatDuration(monthTotalDuration()) }}
                @if (monthRevenuePerHour() !== null && monthHasThresholdEntries()) {
                  <span class="tracker-dot">•</span>
                  P: {{ formatMoney(monthRevenuePerHour()) }}/h
                }

              </p>
            </div>
            <div class="d-flex flex-col">
              <p>
                @if (monthTotalEarnings() > 0) {
                  <span class="tracker-dot">•</span>
                  przychód {{ formatMoney(monthTotalEarnings()) }}
                }
                <span class="tracker-dot">•</span>
                zarobek {{ formatMoney(monthTotalRevenue()) }}
              </p>
            </div>
          </div>

          <div class="tracker-toolbar-actions">
            <div class="tracker-select tracker-select--wide">
              <p-select
                [options]="workItemFilterOptions()"
                optionLabel="name"
                optionValue="id"
                [ngModel]="selectedWorkItemId()"
                (ngModelChange)="onWorkItemFilterChange($event)"
                appendTo="body"
                styleClass="w-full"
              >
                <ng-template let-item pTemplate="item">
                  <div class="tracker-option">
                    <span>{{ item.name || 'Bez nazwy' }}</span>
                    <small>{{ item.clientName || 'Wszystkie wpisy' }}</small>
                  </div>
                </ng-template>
                <ng-template let-item pTemplate="selectedItem">
                  <span>{{ item?.name || 'Wszystkie work itemy' }}</span>
                </ng-template>
              </p-select>
            </div>

            <div class="tracker-select tracker-select--month">
              <p-select
                [options]="monthOptions"
                optionLabel="label"
                optionValue="value"
                [ngModel]="selectedMonth()"
                (ngModelChange)="onMonthChange($event)"
                appendTo="body"
                styleClass="w-full"
              ></p-select>
            </div>

            <div class="tracker-select tracker-select--year">
              <p-select
                [options]="yearOptions()"
                [ngModel]="selectedYear()"
                (ngModelChange)="onYearChange($event)"
                appendTo="body"
                styleClass="w-full"
              ></p-select>
            </div>

            <p-button label="Dziś" outlined (onClick)="goToCurrentMonth()"></p-button>
            <p-button
              icon="pi pi-chevron-left"
              variant="outlined"
              (onClick)="goToPreviousMonth()"
            ></p-button>
            <p-button
              icon="pi pi-chevron-right"
              variant="outlined"
              (onClick)="goToNextMonth()"
            ></p-button>
            <p-button
              [label]="allDayGroupsCollapsed() ? 'Rozwiń wszystkie' : 'Zwiń wszystkie'"
              severity="secondary"
              outlined
              (onClick)="toggleAllDays()"
              [disabled]="monthGroups().length === 0"
            ></p-button>
          </div>
        </div>
      </p-card>
    </div>

    <div class="tracker-sticky-add">
      <p-card>
        <form [formGroup]="quickAddForm" (ngSubmit)="submitQuickAdd()" autocomplete="off">
          <div class="tracker-addbar">
            <div class="tracker-addbar-copy">
              <span class="tracker-eyebrow">Szybkie dodawanie</span>
              <h3>{{ quickAddDateLabel }}</h3>
            </div>

            <div class="tracker-addbar-grid">
              <div class="tracker-field">
                <label for="quickAddWorkItem">Pozycja</label>
                <p-select
                  inputId="quickAddWorkItem"
                  formControlName="workItemId"
                  [options]="quickAddWorkItems"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Wybierz pozycję"
                  appendTo="body"
                  styleClass="w-full"
                >
                  <ng-template let-item pTemplate="item">
                    <div class="tracker-option">
                      <span>{{ item.name || 'Bez nazwy' }}</span>
                      <small>{{ item.clientName || 'Bez klienta' }}</small>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="selectedItem">
                    <span>{{ item?.name || 'Bez nazwy' }}</span>
                  </ng-template>
                </p-select>
              </div>

              <div class="tracker-field">
                <label for="quickAddDate">Data</label>
                <input id="quickAddDate" pInputText formControlName="date" type="date" />
              </div>

              <div
                class="tracker-field"
                [pTooltip]="quickAddRevenueTooltip"
                tooltipPosition="top"
                [tooltipDisabled]="!isQuickAddRevenueLocked()"
              >
                <label for="quickAddRevenue">{{ quickAddRevenueLabel }}</label>
                <p-inputNumber
                  inputId="quickAddRevenue"
                  formControlName="revenueAmount"
                  mode="currency"
                  currency="PLN"
                  locale="pl-PL"
                  [min]="0"
                  [step]="0.01"
                  placeholder="0,00 zł"
                  [disabled]="isQuickAddRevenueLocked()"
                  [readonly]="isQuickAddRevenueLocked()"
                  styleClass="w-full"
                ></p-inputNumber>
              </div>

              <div class="tracker-field tracker-field-time">
                <label for="quickAddStart">Start</label>
                <input
                  id="quickAddStart"
                  pInputText
                  formControlName="start"
                  placeholder="08:00"
                  inputmode="numeric"
                  (click)="onTimeClick('start', $event)"
                  (blur)="onChangeTimeEntry('start')"
                />
              </div>

              <div class="tracker-field tracker-field-time">
                <label for="quickAddEnd">Koniec</label>
                <input
                  id="quickAddEnd"
                  pInputText
                  formControlName="end"
                  placeholder="16:00"
                  inputmode="numeric"
                  (click)="onTimeClick('end', $event)"
                  (blur)="onChangeTimeEntry('end')"
                />
              </div>

              <div class="tracker-field tracker-field-duration">
                <label>Czas</label>
                <input
                  pInputText
                  [value]="quickAddDurationLabel"
                  readonly
                  class="tracker-readonly"
                />
              </div>
            </div>

            <div class="tracker-addbar-actions">
              <span class="tracker-addbar-hint">
                {{
                  hasQuickAddItems ? 'Gotowe do szybkiego zapisu.' : 'Brak dostępnych work itemów.'
                }}
              </span>
              <p-button
                type="submit"
                label="{{ savingQuickAdd() ? 'Zapisywanie...' : 'Dodaj wpis' }}"
                [disabled]="quickAddForm.invalid || savingQuickAdd() || !hasQuickAddItems"
              ></p-button>
            </div>
          </div>
        </form>
      </p-card>
    </div>

    <div class="tracker-list-wrap">
      <ng-container *ngIf="monthGroups().length > 0; else emptyState">
        <p-card
          class="tracker-list-card"
          *ngFor="let group of monthGroups(); trackBy: trackByGroup"
        >
          <div class="tracker-day-header">
            <div>
              <span class="tracker-eyebrow">{{ group.dayLabel }}</span>
              <h3>{{ formatDuration(group.dayTotalDuration) }}</h3>
            </div>

            <div class="tracker-day-totals">
              <span>{{ group.entries.length }} wpisów</span>
              <strong *ngIf="monthHasThresholdEntries() && group.dayTotalRevenue > 0">{{ formatMoney(group.dayTotalRevenue) }}</strong>
              <strong *ngIf="group.dayTotalEarnings > 0">
                {{ formatMoney(group.dayTotalEarnings) }}
              </strong>
            </div>

            <button
              type="button"
              class="tracker-day-toggle"
              (click)="toggleDayCollapsed(group.dayKey)"
              [attr.aria-expanded]="!isDayCollapsed(group.dayKey)"
              [attr.aria-label]="isDayCollapsed(group.dayKey) ? 'Rozwiń dzień' : 'Zwiń dzień'"
            >
              <i
                class="pi"
                [ngClass]="isDayCollapsed(group.dayKey) ? 'pi-chevron-down' : 'pi-chevron-up'"
              ></i>
              <span>{{ isDayCollapsed(group.dayKey) ? 'Rozwiń' : 'Zwiń' }}</span>
            </button>
          </div>

          <div class="tracker-day-summary">
            <span *ngIf="monthHasThresholdEntries() && group.dayTotalRevenue > 0">
              Zarobek:
              <strong>{{ formatMoney(group.dayTotalRevenue) }}</strong>
            </span>
            <span>
              Przychód:
              <strong>{{ formatMoney(group.dayTotalEarnings) }}</strong>
            </span>
            <span *ngIf="group.entries.length > 0">
              Ostatni wpis:
              <strong>{{ formatTimeRange(group.entries[0].start, group.entries[0].end) }}</strong>
            </span>
          </div>

          <div class="tracker-day-body" [class.is-collapsed]="isDayCollapsed(group.dayKey)">
            <div class="tracker-day-body-inner">
              <p-divider></p-divider>

              <div class="tracker-entry-list">
                <button
                  type="button"
                  class="tracker-entry-row"
                  *ngFor="let entry of group.entries; trackBy: trackByEntry"
                  (click)="openEntry(entry)"
                >
                  <div class="tracker-entry-main">
                    <div class="tracker-entry-top">
                      <span class="tracker-entry-time">
                        {{ formatTimeRange(entry.start, entry.end) }}
                      </span>
                      <div class="tracker-entry-amounts">
                        @if (entry.billingMode === 'HOURLY_RATE') {
                          <span class="tracker-entry-revenue">
                            Przychód {{ formatMoneyOrDash(resolveEntryEarnings(entry)) }}
                          </span>
                        }
                        @if (entry.billingMode === 'REVENUE_THRESHOLD') {
                          <span
                            class="tracker-entry-earnings"
                            *ngIf="resolveEntryEarnings(entry) != null"
                          >
                            Przychód {{ formatMoneyOrDash(resolveEntryEarnings(entry)) }}
                          </span>
                          <span
                            class="tracker-entry-revenue"
                            *ngIf="resolveEntryEarnings(entry) != null"
                          >
                            <small>
                              Zarobek {{ formatMoneyOrDash(resolveEntryRevenue(entry)) }}
                            </small>
                          </span>
                        }
                      </div>
                    </div>

                    <div class="tracker-entry-title">
                      <span>{{ entry.workItemName || 'Bez nazwy' }}</span>
                      <small>{{ entry.clientName || 'Brak klienta' }}</small>
                    </div>

                    <p class="tracker-entry-desc">{{ entry.description || 'Brak opisu' }}</p>
                  </div>

                  <div class="tracker-entry-meta">
                    <span>{{ formatDuration(entry.duration) }}</span>
                    <span>{{ formatDateTime(entry.createdDate) }}</span>
                    <span>{{ entry.createdByUserName ?? 'Nieznany autor' }}</span>
                    <span *ngIf="entry.editableByCurrentUser === false" class="tracker-entry-lock">
                      Tylko do odczytu
                    </span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </p-card>
      </ng-container>

      <ng-template #emptyState>
        <p-card>
          <div class="tracker-empty-state">
            <i class="pi pi-calendar-times"></i>
            <h4>{{ emptyStateTitle() }}</h4>
            <p>{{ emptyStateDescription() }}</p>
          </div>
        </p-card>
      </ng-template>
    </div>
  </ng-container>
</app-page-wrapper>
